import { Button, DialogActions, DialogContentText, DialogTitle, Typography } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { abyssColors } from '@/theme/colors';
type ButtonProps = {
  contained?: boolean;
  compact?: boolean;
};

const ActionButton = muiStyled(Button)(({ contained, compact }: ButtonProps) => ({
  padding: compact ? '0.8rem 1.2rem' : '0.8rem 1.8rem',
  height: '3.4rem',
  borderRadius: '0.4rem',
  fontSize: '1.4rem',
  background: contained ? abyssColors.primary[500] : abyssColors.neutral[50],
  color: contained ? abyssColors.neutral[50] : abyssColors.primary[500],
  boxShadow: 'none',
  textTransform: 'none',
  width: 'fit-content',
  lineHeight: 'normal',
  marginLeft: '0px !important',
  gap: '0.6rem',
  '&:disabled': {
    background: contained ? abyssColors.neutral[300] : abyssColors.neutral[50],
    color: contained ? abyssColors.neutral[50] : abyssColors.primary[300],
  },
  '&:hover': {
    background: contained ? abyssColors.primary[400] : abyssColors.neutral[50],
  },
}));

export const Header = muiStyled(DialogTitle)(() => ({
  padding: '3.2rem',
  paddingBottom: '2.4rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const SubHeading = muiStyled(DialogContentText)(() => ({
  paddingBottom: '2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const TitleText = muiStyled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '2rem',
  lineHeight: 'normal',
  color: abyssColors.primary[500],
}));

export const Footer = muiStyled(DialogActions)(() => ({
  height: '6.2rem',
  padding: '1.6rem 3.2rem',
  borderTop: '1px solid rgba(101, 130, 164, 0.20)',
}));

export const DialogActionButton = muiStyled(ActionButton)(() => ({
  fontSize: '1.2rem',
  height: '3rem',
  padding: '0px 30px',
}));
